export const PAYER_ROLES = ["admin", "supervisor"];

export const PAYER_ROLE_REQUIRED_MESSAGE = "Solo un administrador o supervisor de la cuenta puede hacer pagos.";

export type TopupPayer = "member" | "super_admin";

export function canPay(role: string | null | undefined): boolean {
  return !!role && PAYER_ROLES.includes(role);
}

export function topupPayer(role: string | null | undefined, isSuperAdmin: boolean): TopupPayer | null {
  if (canPay(role)) return "member";
  return isSuperAdmin ? "super_admin" : null;
}

export function canTopUp(role: string | null | undefined, isSuperAdmin: boolean): boolean {
  return topupPayer(role, isSuperAdmin) !== null;
}

export function canResolveStandingAction(
  action: "pay" | "plan" | "top_up" | "support",
  role: string | null | undefined,
  isSuperAdmin: boolean,
): boolean {
  if (action === "support") return true;
  return action === "pay" ? canPay(role) : canTopUp(role, isSuperAdmin);
}
